import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import Goods from "../../../pages/tunder/goods/goods";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const GoodsApp = () => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="Тандер"
        title="Товары"
        headBlockChildren={
          <>
            <HeaderBtn
              content="Выгрузка SKU"
              purpose="skuUnload"
              modalTitle="Выгрузка SKU"
            />
            <HeaderBtn
              content="Загрузка SKU"
              purpose="skuload"
              modalTitle="Загрузить SKU"
            />
          </>
        }
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/shops" className="tab">
                <div className="buttons__btn">Торговые точки</div>
              </Link>
            )}
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/signals" className="tab">
                <div className="buttons__btn">Сигналы</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/properties" className="tab">
                <div className="buttons__btn">Настройки</div>
              </Link>
            )}
            <Link to="/tunder/goods" className="tab">
              <div className="buttons__btn --active">Товары</div>
            </Link>
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/access" className="tab">
                <div className="buttons__btn">Доступы</div>
              </Link>
            )}
          </div>
          <Goods />
        </div>
      </SectionContent>
    </div>
  );
};

export default GoodsApp;
